import React, { useState, useEffect } from 'react';

function PartDecodeImg(props) {

  const [OpenCV, setOpenCV] = useState(null);
  const [inDeSrc, setInDeSrc] = useState();
  const [outDeSrc, setOutDeSrc] = useState();
  const [defilename, setDeFileName] = useState();
  // const [lable, setLable] = useState('暂未上传图片');

  useEffect(() => {
    setOpenCV(props.opencv)
  }, [props.opencv]);


  /**为加快dft，对要处理的图片尺寸进行优化 */
  function optimizeImageDim(mat) {
    // get optimal size of DFT
    let optimalRows = OpenCV.getOptimalDFTSize(mat.rows);
    let optimalCols = OpenCV.getOptimalDFTSize(mat.cols);
    let s0 = OpenCV.Scalar.all(0);
    let padded = new OpenCV.Mat();
    OpenCV.copyMakeBorder(mat, padded, 0, optimalRows - mat.rows, 0,
      optimalCols - mat.cols, OpenCV.BORDER_CONSTANT, s0);

    return padded
  }

  function dftOnePlane(plane) {

    plane.convertTo(plane, OpenCV.CV_32F);

    //为实部虚部构建 MatVector
    let planes = new OpenCV.MatVector();
    //添加进 planes
    planes.push_back(plane);
    planes.push_back(new OpenCV.Mat.zeros(plane.size(), OpenCV.CV_32F));

    //合并到 complexI
    let complexI = new OpenCV.Mat();
    OpenCV.merge(planes, complexI);

    //dft
    OpenCV.dft(complexI, complexI);

    return complexI;
  }

  function shiftDFT(mag) {
    // crop the spectrum, if it has an odd number of rows or columns
    let rect = new OpenCV.Rect(0, 0, mag.cols & -2, mag.rows & -2);
    mag = mag.roi(rect);
    // rearrange the quadrants of Fourier image
    // so that the origin is at the image center
    let cx = mag.cols / 2;
    let cy = mag.rows / 2;
    let tmp = new OpenCV.Mat();
    let rect0 = new OpenCV.Rect(0, 0, cx, cy);
    let rect1 = new OpenCV.Rect(cx, 0, cx, cy);
    let rect2 = new OpenCV.Rect(0, cy, cx, cy);
    let rect3 = new OpenCV.Rect(cx, cy, cx, cy);
    let q0 = mag.roi(rect0);
    let q1 = mag.roi(rect1);
    let q2 = mag.roi(rect2);
    let q3 = mag.roi(rect3);
    // exchange 1 and 4 quadrants
    q0.copyTo(tmp);
    q3.copyTo(q0);
    tmp.copyTo(q3);
    // exchange 2 and 3 quadrants
    q1.copyTo(tmp);
    q2.copyTo(q1);
    tmp.copyTo(q2);
  }


  function decodeImg(e) {
    // 加载
    let src = OpenCV.imread(e.target);
    // 尺寸优化
    let opsrc = optimizeImageDim(src);

    // 获得所有通道
    let allPlanes = new OpenCV.MatVector();
    OpenCV.split(opsrc, allPlanes);

    let deAllPalanes = new OpenCV.MatVector();

    //获得一通道
    let plane0 = new OpenCV.Mat();
    plane0 = allPlanes.get(0);

    //对该通道进行dft
    let complexI = dftOnePlane(plane0);


    // compute log(1 + sqrt(Re(DFT(img))**2 + Im(DFT(img))**2))
    let newPlanes = new OpenCV.MatVector();
    let mag = new OpenCV.Mat();
    OpenCV.split(complexI, newPlanes);
    OpenCV.magnitude(newPlanes.get(0), newPlanes.get(1), mag);
    OpenCV.add(new OpenCV.Mat.ones(mag.size(), OpenCV.CV_32F), mag, mag);
    OpenCV.log(mag, mag);


    shiftDFT(mag);


    mag.convertTo(mag, OpenCV.CV_8UC1);
    OpenCV.normalize(mag, mag, 0, 255, OpenCV.NORM_MINMAX, OpenCV.CV_8UC1);

    //合并通道
    deAllPalanes.push_back(mag)

    let lastImage = new OpenCV.Mat();
    OpenCV.merge(deAllPalanes, lastImage);

    OpenCV.imshow('deCanvas', lastImage);
    setInDeSrc('')
    let canvas = document.getElementById('deCanvas');
    let href = canvas.toDataURL("image/png", 1);
    setOutDeSrc(href)
    canvas.width = 1;
    canvas.height = 1;
    // setLable('完成解密,点击下载')
  }
  return (
    <div className="col-md-12 p-2">
      <div className="h-100 p-5 pb-4 bg-light border rounded-3">
        <h2>解密</h2>
        <p>对图片G通道进行傅里叶变换，shiftDFT，将结果生成图片</p>

        <input type="file"
          style={{ width: 200, marginTop: 10 }}
          onChange={(e) => {
            setInDeSrc(URL.createObjectURL(e.target.files[0]))
            let name = e.target.files[0].name;
            setDeFileName(name.substring(0, name.indexOf(".")))
            // setLable('上传成功,正在处理...')
            // console.log('url', URL.createObjectURL(e.target.files[0]))
          }} />

        {inDeSrc ?
          <img
            alt=' '
            src={inDeSrc}
            onLoad={(e) => {
              if (OpenCV) {
                console.log('---OpenCV---', OpenCV)
                decodeImg(e);
              }
            }}
          ></img> : ''
        }


        <canvas
          id="deCanvas"
          width={1}
          height={1}
        ></canvas>

        {outDeSrc ?
          <a className="btn btn-outline-dark mt-4" type="button"
            style={{
              width: 100,
              display: 'block'
            }}
            href={outDeSrc}
            download={'encode-' + defilename}
          >
            下载结果
          </a>
          :
          ''
        }

      </div>
    </div>
  )
}

export default PartDecodeImg;